export enum CasinoConfigQueryKeys {
  CasinoConfig = "casino-config",
}
